import React from 'react';
import { Layout } from '../components/Layout';
import { SEO, pageSEO } from '../components/SEO';
import { Card, CardContent } from '../components/ui/Card';
import { Target, Eye, Heart, CheckCircle2, GraduationCap, Briefcase, TrendingUp, Recycle, Award } from 'lucide-react';
export function AboutPage() {
  return <Layout data-id="element-132" data-mp="67h382c9vfh">
      <SEO {...pageSEO.about} data-id="element-133" data-mp="6gy465eos91" />
      {/* Header */}
      <div className="bg-[#2C3E50] text-white py-16" data-id="element-134" data-mp="3rda7vye9lzp6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-135" data-mp="3raxgyvqj4ezz">
          <h1 className="text-4xl font-bold mb-4" data-id="element-136" data-mp="3mcdumu80x173">À Propos de l'ADCC</h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-137" data-mp="3ibk8a5a8bugb">
            Une approche complète : de la montée en compétences à l'emploi digne
          </p>
        </div>
      </div>

      {/* Notre Approche */}
      <section className="py-20 bg-white" data-id="element-138" data-mp="1gjnwqvo2aklj">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-139" data-mp="1blw41zfleuga">
          <div className="text-center mb-12" data-id="element-140" data-mp="1bmfaaivvrueh">
            <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm" data-id="element-141" data-mp="2ewh697s3ve9c">
              Notre Approche
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-6" data-id="element-142" data-mp="2jw3knkjo70jq">
              Une chaîne de valeur complète
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-143" data-mp="2aum98fh7jn1d">
              L'ADCC développe une chaîne de valeur complète pour garantir un
              impact réel, mesurable et durable.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-12" data-id="element-144" data-mp="32m1sbzjk2rmu">
            {[{
            icon: GraduationCap,
            title: 'Développer',
            desc: 'Acquisition de compétences techniques et humaines',
            color: 'bg-blue-50'
          }, {
            icon: Award,
            title: 'Tester',
            desc: 'Validation des acquis et professionnalisation',
            color: 'bg-green-50'
          }, {
            icon: Briefcase,
            title: 'Insérer',
            desc: "Mise en relation avec des opportunités d'emploi",
            color: 'bg-purple-50'
          }, {
            icon: TrendingUp,
            title: 'Suivre',
            desc: 'Accompagnement post-placement et amélioration continue',
            color: 'bg-amber-50'
          }, {
            icon: Recycle,
            title: 'Recycler',
            desc: 'Reconversion et mise à jour des compétences',
            color: 'bg-teal-50'
          }].map((step, index) => <Card key={index} className="text-center h-full" data-id="element-145" data-mp="2yisilhy9x5o0" data-mpi={index}>
                <CardContent className="pt-6 pb-4" data-id="element-146" data-mp="2yg6clmr16y7w">
                  <div className={`inline-flex items-center justify-center p-3 ${step.color} rounded-full mb-3`} data-id="element-147" data-mp="2thmp3hwshedf">
                    <step.icon className="w-7 h-7 text-[#1E88E5]" data-id="element-148" data-mp="14zaee8z9wba6" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-149" data-mp="151mxipgrorot">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-150" data-mp="1dzgrhtr2798t">{step.desc}</p>
                </CardContent>
              </Card>)}
          </div>

          <div className="bg-gradient-to-r from-[#1E88E5] to-[#1976D2] text-white rounded-2xl p-8 md:p-12" data-id="element-151" data-mp="1iya1vdb1uk4r">
            <h3 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-152" data-mp="l985trxbe6ph">
              Nos objectifs 2026
            </h3>
            <p className="text-lg text-blue-100 mb-8" data-id="element-153" data-mp="v9h3la6yg06z">
              L'ADCC se fixe des objectifs ambitieux pour l'année 2026, avec une
              vision claire de l'impact que nous souhaitons avoir sur les
              communautés que nous servons.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-154" data-mp="2kjn9cmb0dgv">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4" data-id="element-155" data-mp="7iux3nclmnz3">
                <p className="text-3xl font-bold mb-2" data-id="element-156" data-mp="298k9fscuqacb">100</p>
                <p className="text-sm text-blue-100" data-id="element-157" data-mp="296zgg766qzgk">
                  Personnes à accompagner en 2026
                </p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4" data-id="element-158" data-mp="2izetqr6jezv4">
                <p className="text-3xl font-bold mb-2" data-id="element-159" data-mp="2e85aq9fhuus7">60%</p>
                <p className="text-sm text-blue-100" data-id="element-160" data-mp="2e6u667e85j01">
                  Taux de placement envisagé en 2026
                </p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4" data-id="element-161" data-mp="2ny89kq9ar2yg">
                <p className="text-3xl font-bold mb-2" data-id="element-162" data-mp="2o0ay15uswo12">100%</p>
                <p className="text-sm text-blue-100" data-id="element-163" data-mp="31wg1gjrh7e2r">
                  D'insertion éthique et transparente en 2026
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Notre Engagement */}
      <section className="py-20 bg-gray-50" data-id="element-164" data-mp="12kn60rkc6gs5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-165" data-mp="12lx3pfna1my9">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-166" data-mp="3e7gus4omuk8z">
            <div data-id="element-167" data-mp="3j7251b996f10">
              <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm" data-id="element-168" data-mp="3j7ld8093pp1u">
                Notre Engagement Éthique
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-6" data-id="element-169" data-mp="35dkmntsaz8ck">
                Une insertion responsable et digne
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-170" data-mp="2vh7rssl0uog8">
                Nous œuvrons pour une insertion responsable, fondée sur des
                valeurs fortes et un cadre éthique rigoureux.
              </p>
              <div className="space-y-4" data-id="element-171" data-mp="2midqwq0nrbwv">
                {[{
                title: 'La dignité du travail',
                desc: 'Respect des droits et de la personne dans toutes les relations professionnelles'
              }, {
                title: 'La transparence des conditions',
                desc: "Clarté sur les conditions d'emploi, rémunération et responsabilités"
              }, {
                title: 'Le respect des personnes',
                desc: 'Valorisation de chaque individu et de son parcours professionnel'
              }, {
                title: 'La valorisation des compétences acquises',
                desc: 'Reconnaissance et mise en valeur des formations certifiantes'
              }].map((item, index) => <div key={index} className="flex items-start gap-4 bg-white p-4 rounded-lg shadow-sm" data-id="element-172" data-mp="2cde3n9v5mota" data-mpi={index}>
                    <CheckCircle2 className="w-6 h-6 text-[#1E88E5] flex-shrink-0 mt-1" data-id="element-173" data-mp="22nulk6f9myzh" />
                    <div data-id="element-174" data-mp="302yoxzes5y5q">
                      <h4 className="font-bold text-gray-900 mb-1" data-id="element-175" data-mp="3038ghrfh4ddj">
                        {item.title}
                      </h4>
                      <p className="text-sm text-gray-600" data-id="element-176" data-mp="2v9ng5sqer7b6">{item.desc}</p>
                    </div>
                  </div>)}
              </div>
            </div>
            <div data-id="element-177" data-mp="37mhphjk2ia22">
              <img src="https://cdn.magicpatterns.com/uploads/jfY9WFQQPLNmCKBmbcpuEW/Femmes_Menage_Emploi_3.png" alt="Formation et certification ADCC" className="rounded-2xl shadow-xl w-full" data-id="element-178" data-mp="37o27yat3y2jk" />
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 bg-white" data-id="element-179" data-mp="3qkaedhxuwjgg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-180" data-mp="3qizeht7j7vum">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-181" data-mp="3vbafz0hx7ppa">
            <div className="order-2 lg:order-1" data-id="element-182" data-mp="45r2pt09nido">
              <div className="bg-gradient-to-br from-blue-50 to-gray-100 rounded-2xl p-12 flex items-center justify-center" data-id="element-183" data-mp="44fyxt6tmamk">
                <img src="https://cdn.magicpatterns.com/uploads/igFPFWe6QurLv1Fq8d9zkK/logo_sans_texte.png" alt="ADCC - Symbole de croissance et d'accompagnement" className="w-full max-w-[300px] h-auto" data-id="element-184" data-mp="84zyt4is3sce" />
              </div>
            </div>
            <div className="order-1 lg:order-2" data-id="element-185" data-mp="18es5vqog5hkv">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-186" data-mp="18ejslxoewa95">
                Notre Histoire
              </h2>
              <div className="prose prose-lg text-gray-600" data-id="element-187" data-mp="13dw1zd43hvfg">
                <p className="mb-4" data-id="element-188" data-mp="frfso746em48">
                  L'Association Dignité Compétence Création (ADCC) est née il y
                  a quelques mois au Bénin, animée par la détermination d'un
                  groupe de professionnels engagés à transformer le destin des
                  femmes, des jeunes et des travailleurs invisibles. Notre
                  mission ? Combattre la précarité en les autonomisant et en
                  facilitant leur insertion professionnelle durable.
                </p>
                <p className="mb-4" data-id="element-189" data-mp="3o5ogl1vr6oq2">
                  Nos premiers pas ont été marqués par un forum d'état des
                  lieux, qui a réuni ces acteurs oubliés pour cartographier
                  leurs besoins et aspirations. Aujourd'hui, déjà reconnue,
                  l'ADCC accélère ses ambitions sur plusieurs fronts : formation
                  professionnelle adaptée, certification reconnue, placement en
                  emploi et suivi post-insertion. Avec votre confiance et votre
                  appui, nous amplifierons cet élan pour un impact national.
                </p>
                <p data-id="element-190" data-mp="2rd7xsrde4urq">
                  Notre nom porte nos piliers : restaurer la Dignité humaine,
                  forger les Compétences techniques et intellectuelles, et
                  libérer la Création de valeur et d'opportunités d'emplois
                  pérennes. Ensemble, écrivons les prochaines pages de cette
                  aventure transformative !
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision, Mission, Values */}
      <section className="py-20 bg-gray-50" data-id="element-191" data-mp="1qoccnhl4mhxz">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-192" data-mp="1vmdszur6435r">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-193" data-mp="1vormhz6797b7">
            <Card className="text-center h-full" data-id="element-194" data-mp="1huh8ocvqqxjx">
              <CardContent className="pt-8" data-id="element-195" data-mp="1lwubasf6yfch">
                <div className="inline-flex items-center justify-center p-4 bg-blue-50 rounded-full mb-6" data-id="element-196" data-mp="1lvj8autklbmf">
                  <Target className="w-8 h-8 text-[#1E88E5]" data-id="element-197" data-mp="17vhwikbrojs6" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-198" data-mp="1cx76dwn96reo">
                  Notre Mission
                </h3>
                <p className="text-gray-600" data-id="element-199" data-mp="yy7k2vn7qolo">
                  Accompagner les populations vulnérables vers l'autonomie
                  financière et sociale à travers des programmes de renforcement
                  de capacités adaptés, et un accompagnement à l'insertion
                  professionnelle durable.
                </p>
              </CardContent>
            </Card>

            <Card className="text-center h-full" data-id="element-200" data-mp="lpgrk0d65fee">
              <CardContent className="pt-8" data-id="element-201" data-mp="hnc3dh5hpaz5">
                <div className="inline-flex items-center justify-center p-4 bg-blue-50 rounded-full mb-6" data-id="element-202" data-mp="hodchg2y3ne8">
                  <Eye className="w-8 h-8 text-[#1E88E5]" data-id="element-203" data-mp="vg1pdll0qfw9" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-204" data-mp="qmpbo6hvntia">
                  Notre Vision
                </h3>
                <p className="text-gray-600" data-id="element-205" data-mp="15atnqrmfd6s3">
                  Un Bénin où chaque individu, quel que soit son milieu
                  d'origine, a les moyens de construire sa vie avec dignité,
                  d'accéder à un emploi décent, et de contribuer au progrès de
                  sa communauté.
                </p>
              </CardContent>
            </Card>

            <Card className="text-center h-full" data-id="element-206" data-mp="3g5r1vry91pls">
              <CardContent className="pt-8" data-id="element-207" data-mp="3g6iyn63l1tdn">
                <div className="inline-flex items-center justify-center p-4 bg-blue-50 rounded-full mb-6" data-id="element-208" data-mp="3b6o853npz5t4">
                  <Heart className="w-8 h-8 text-[#1E88E5]" data-id="element-209" data-mp="1f3rvxmk7g6xg" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-210" data-mp="1k0rtta6wi3dh">
                  Nos Valeurs
                </h3>
                <ul className="text-gray-600 space-y-2" data-id="element-211" data-mp="1ozuu6hbxrlf4">
                  {['Dignité et Respect', 'Intégrité et Transparence', 'Excellence et Innovation', 'Insertion Durable'].map((val, idx) => <li key={idx} data-id="element-212" data-mp="22yulxxuqwgfi" data-mpi={idx}>{val}</li>)}
                </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </Layout>;
}